import React, { Fragment } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ChatBox from "./ChatBox";

const AiChat = () => {
    const location = useLocation();
    const type = location?.search?.split("=")[1];
    return (
        <Fragment>
            <PageHeader
                title={`DCP AI ${type === 'coach' ? 'SAT/ACT Coach' : type === 'mentor' ? 'Project Mentor' : type === 'tutor' ? 'Tutor' : 'Counselor'}`}
                content={
                    <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                        How can i help you?
                    </Typography>
                }
            />
            <ChatBox />
        </Fragment>
    )
}

export default AiChat;